import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "../components/layout/Layout";

// Pages
import Home from "../pages/Home/Home";
import About from "../pages/About/About";
import Tutorials from "../pages/Tutorials/Tutorials";

// Auth
import Login from "../pages/Auth/Login";
import Signup from "../pages/Auth/Signup";

// Courses
import BasicExcelCourse from "../pages/Tutorials/Basic_Excel_Course/basic_excel_course";
import BasicSqlCourse from "../pages/Tutorials/Basic_SQL/basic_sql_course";
import PythonCourse from "../pages/Tutorials/Basic_Python/basic_python_course";

// 404 Page (Professional)
const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "60px", marginBottom: "10px" }}>404</h1>
      <p style={{ fontSize: "18px", color: "#64748b" }}>
        Oops! The page you're looking for doesn't exist.
      </p>
    </div>
  );
};

function AppRoutes() {
  return (
    <Layout>
      <Routes>

        {/* ================= PUBLIC ROUTES ================= */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tutorials" element={<Tutorials />} />

        {/* ================= AUTH ROUTES ================= */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* ================= COURSE ROUTES ================= */}
        <Route path="/tutorials/basic-excel" element={<BasicExcelCourse />} />
        <Route path="/tutorials/basic-sql" element={<BasicSqlCourse />} />
        <Route path="/tutorials/python-basics" element={<PythonCourse />} />

        {/* ================= 404 ================= */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </Layout>
  );
}

export default AppRoutes;